import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import React, { useRef } from "react";
import ArrowDown from "../../Assets/Images/Arrowdown.svg";
import NavBar from "../../Components/NavBar";
import "./product.css";
import { useTranslation } from "../../Hooks/useTranslation"; // Import the hook
import { useAnimateOnScroll } from "../../Hooks/useAnimationScroll"; // Add this import
import HomeOverlayElement1 from "../../Assets/Images/home-overlay-element-1.png";
import HomeOverlayElement3 from "../../Assets/Images/home-overlay-element-2.png";
import HomeOverlayElement2 from "../../Assets/Images/home-overlay-element-3.png";

import HomeOverlayMobileElement3 from "../../Assets/Images/term-overlay-element-mobile-1.png";
import HomeOverlayMobileElement2 from "../../Assets/Images/term-overlay-element-mobile-2.png";

import BenefitsIcon1 from "../../Assets/Images/benefit-icon1.svg";
import BenefitsIcon2 from "../../Assets/Images/benefit-icon2.svg";
import BenefitsIcon3 from "../../Assets/Images/benefit-icon3.svg";
import BenefitsIcon4 from "../../Assets/Images/benefit-icon4.svg";
import BenefitsImage from "../../Assets/Images/benefits-img.png";

import BenefitsIconMobile1 from "../../Assets/Images/benefit-icon-mobile1.png";
import BenefitsIconMobile2 from "../../Assets/Images/benefit-icon-mobile2.svg";
import BenefitsIconMobile3 from "../../Assets/Images/benefit-icon-mobile3.svg";
import BenefitsIconMobile4 from "../../Assets/Images/benefit-icon-mobile4.svg";
import BenefitsMobileImage from "../../Assets/Images/benefits-mobile-img.png";

import TermBenefitsImage from "../../Assets/Images/term-benefits-img.png";
import BenefitSectionPlanPage from "../../Components/BenitsPlan/BenefitSectionPlanPage";
import FAQs from "../../Components/FAQs";
import HealthInsuranceHero from "../../Components/HealthInsuranceHero";

import BenefitsSlider from "./BenefitsMobileSlider";

gsap.registerPlugin(ScrollTrigger);

const TermLifeInsurance = () => {
  const translations = useTranslation(); // Get translations dynamically
  const bannerRef = useRef(null);
  const productRef = useRef(null);
  const credentialsRef = useRef(null);
  const scrollToRef = useRef(null);
  const benefitsRef = useRef(null);

  // Add this hook to enable scroll-based animations
  useAnimateOnScroll();

  const scrollToContent = () => {
    benefitsRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="main-container">
      <NavBar />

      <section className="panel" ref={bannerRef}>
        <div className="home-welcome terms-life-banner container-fluid">
          <div className="termlife-overlay-bg md:!hidden"></div>
          <div className="home-welcome-overlay-element md:hidden">
            <div className="absolute w-full h-full z-[6] reveal-up">
              <img
                alt="overlay-element"
                className="home-welcome-overlay-element--one hidden md:block"
                src={HomeOverlayElement2}
              />
              <img
                alt="overlay-element"
                className="home-welcome-overlay-element--one block md:hidden"
                src={HomeOverlayMobileElement3}
              />
            </div>
            <div className="absolute w-full h-full z-[4] reveal-up">
              <img
                alt="overlay-element"
                className="home-welcome-overlay-element--two hidden md:block"
                src={HomeOverlayElement3}
              />
              <img
                alt="overlay-element"
                className="home-welcome-overlay-element--two block md:hidden"
                src={HomeOverlayMobileElement2}
              />
            </div>
            <div className="absolute w-full h-full z-[6] reveal-up">
              <img
                alt="overlay-element"
                className="home-welcome-overlay-element--three "
                src={HomeOverlayElement1}
              />
            </div>
          </div>
          <div className="absolute container z-[6] left-0 right-0">
            <div className="h-full flex items-center max-w-[512px] md:pl-0 px-4 term-life-banner-caption">
              <div className="relative md:mb-[100px]">
                <h1 className="mb-4 md:leading-[33px] xl:leading-[2.8rem] md:text-[30px] xl:text-[2.5rem] text-[24px] leading-[28px] font-semibold tracking-[-0.5px] md:tracking-[-0.6px] xl:tracking-[-0.5px]  reveal-up extra-title-heading reveal-up">
                  {translations.termsBannerHeading}
                </h1>
                <p className="mb-4 text-[14px] leading-normal md:text-[10.5px] md:leading-[16.5px] xl:text-[14px] xl:leading-normal worldclstext max-w-[488px] lg:max-w-[366px] xl:max-w-[488px] reveal-up extra-para-vs">
                  {translations.termsBannerDescription}
                </p>
                <div className="text-teal-900 px-8 py-2 pl-0 rounded-full text-lg font-semibold md:hidden block">
                  <div className="flex space-x-3 text-white items-center">
                    <div className="border-radius scrollarrow arrow-border flex items-center justify-center border-2 border-white rounded-full w-[88px] h-[50px] cursor-pointer">
                      <img
                        src={ArrowDown}
                        alt="Scroll down arrow"
                        className="animate__animated animate__bounce animate__delay-2s animate__repeat-3"
                      />
                    </div>
                    <span className="hidden lg:block text-lg font-medium scrollToSeeMore">
                      {translations.aboutUsBannerButton}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="absolute container z-[6] left-0 right-0 bottom-16 md:block hidden">
            <div className="text-teal-900 px-8 py-2 pl-0 rounded-full text-lg font-semibold">
              <div className="flex space-x-3 text-white items-center">
                <div
                  className="border-radius scrollarrow arrow-border flex items-center justify-center border-2 border-white rounded-full w-[88px] h-[50px] cursor-pointer"
                  onClick={scrollToContent}
                >
                  <img
                    src={ArrowDown}
                    alt="Scroll down arrow"
                    className="animate__animated animate__bounce animate__delay-2s animate__repeat-3"
                  />
                </div>
                <span className="hidden lg:block text-lg font-medium scrollToSeeMore">
                  {translations.aboutUsBannerButton}
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="panel lg:block hidden" ref={benefitsRef}>
        <BenefitSectionPlanPage coverImage={TermBenefitsImage} />
      </section>

      <section className="lg:hidden block">
        <BenefitsSlider />
      </section>

      <section className="panel" ref={credentialsRef}>
        <div
          id="improve-benefits"
          className="improve-benefits-option py-[4rem] md:pt-[8rem] md:pb-[6rem] lg:py-[6rem]"
        >
          <div className="lg:container container-fluid lg:pr-4 pr-0">
            <div className="lg:px-0 px-8">
              <div className="text-sm text-gray-600 mb-1 learnmoreacc block lg:hidden reveal-up">
                {translations.select_term}
              </div>
              <h2 className="lg:text-center md:text-[30px] xl:text-[40px] text-[24px] md:leading-[33px] xl:leading-[1.5] leading-[28px] mb-10 tracking-tight hidden md:block reveal-up extra-title-heading">
                <strong className="font-semibold">
                  {translations.improve_protection}
                </strong>{" "}
                <br className="hidden md:inline lg:hidden" />
                {translations.with_additional_benefits}
              </h2>
              <h2 className="lg:text-center md:text-[30px] xl:text-[40px] text-[24px] md:leading-[33px] xl:leading-[1.5] leading-[28px] mb-10 tracking-tight block md:hidden reveal-up">
                <strong className="font-semibold">
                  Improve your protection with
                </strong>{" "}
                Additional Benefit Options
              </h2>
            </div>
            <div className="flex items-center justify-center lg:flex hidden">
              <div className="max-w-[324px] improve-benefits-colum-vs">
                <div className="benefits-grid my-16 reveal-up reveal-delay-1">
                  <div className="b-icon bg-[#D8ECED] mb-4 h-[47px] w-[67px] flex justify-center items-center rounded-[24px]">
                    <img src={BenefitsIcon1} alt="Benefits Icon" />
                  </div>
                  <h3 className="text-[1rem] md:text-[12px] md:leading-[16px] xl:text-[1rem] xl:leading-[20px] font-semibold mb-2 tracking-tight leading-[20px] extra-title24">
                    {translations.waiver_premium_title}
                  </h3>
                  <p className="text-[14px] leading-[22px] md:text-[10.5px] md:leading-[16.5px] xl:text-[14px] xl:leading-[22px] tracking-tight extra-para-vs">
                    {translations.waiver_premium_desc}
                    <br /> <span className="text-[#A8A9AC]">(LR148B )</span>
                  </p>
                </div>
                <div className="benefits-grid my-16 reveal-up reveal-delay-3">
                  <div className="b-icon bg-[#D8ECED] mb-4 h-[47px] w-[67px] flex justify-center items-center rounded-[24px]">
                    <img src={BenefitsIcon2} alt="Benefits Icon" />
                  </div>
                  <h3 className="text-[1rem] md:text-[12px] md:leading-[16px] xl:text-[1rem] xl:leading-[20px] font-semibold mb-2 tracking-tight leading-[20px] extra-title24">
                    {translations.accidental_death_title}
                  </h3>
                  <p className="text-[14px] leading-[22px] md:text-[10.5px] md:leading-[16.5px] xl:text-[14px] xl:leading-[22px] tracking-tight extra-para-vs">
                    {translations.accidental_death_desc} <br />{" "}
                    <span className="text-[#A8A9AC]">(LR195B )</span>
                  </p>
                </div>
              </div>
              <div className="mx-12 improve-benefits-image-vs reveal-up">
                <img src={BenefitsImage} alt="" width={251} height={617} />
              </div>
              <div className="max-w-[324px] improve-benefits-colum-vs">
                <div className="benefits-grid my-16 reveal-up reveal-delay-2">
                  <div className="b-icon bg-[#D8ECED] mb-4 h-[47px] w-[67px] flex justify-center items-center rounded-[24px]">
                    <img src={BenefitsIcon3} alt="Benefits Icon" />
                  </div>
                  <h3 className="text-[1rem] md:text-[12px] md:leading-[16px] xl:text-[1rem] xl:leading-[20px] font-semibold mb-2 tracking-tight leading-[20px] extra-title24">
                    {translations.return_premium_title}
                  </h3>
                  <p className="text-[14px] leading-[22px] md:text-[10.5px] md:leading-[16.5px] xl:text-[14px] xl:leading-[22px] tracking-tight extra-para-vs">
                    {translations.return_premium_desc}
                    <br /> <span className="text-[#A8A9AC]">(LR-151B )</span>
                  </p>
                </div>
                <div className="benefits-grid my-16 reveal-up reveal-delay-4">
                  <div className="b-icon bg-[#D8ECED] mb-4 h-[47px] w-[67px] flex justify-center items-center rounded-[24px]">
                    <img src={BenefitsIcon4} alt="Benefits Icon" />
                  </div>
                  <h3 className="text-[1rem] md:text-[12px] md:leading-[16px] xl:text-[1rem] xl:leading-[20px] font-semibold mb-2 tracking-tight leading-[20px] extra-title24">
                    {translations.additional_insured_title}
                  </h3>
                  <p className="text-[14px] leading-[22px] md:text-[10.5px] md:leading-[16.5px] xl:text-[14px] xl:leading-[22px] tracking-tight extra-para-vs">
                    {translations.additional_insured_desc}
                    <br /> <span className="text-[#A8A9AC]">(LR150B )</span>
                  </p>
                </div>
              </div>
            </div>

            <ul className="flex lg:justify-center overflow-auto whitespace-nowrap lg:mb-[5rem] lg:hidden block">
              <li className="lg:px-2.5 px-1 md:w-[270px] min-w-[208px] md:min-w-[250px] whitespace-normal reveal-up reveal-delay-1">
                <div className="bg-[#F7F6F2] rounded-full md:px-5 px-[14px] md:py-24 h-full md:min-h-[505px] pt-[70px] pb-10">
                  <img src={BenefitsIconMobile1} className="mb-4" alt="" />
                  <h3 className="md:text-[14px] text-[14px] md:leading-[18px] leading:[20px] font-semibold mb-4 text-[#0D4248]">
                    {translations.waiver_premium_title}
                  </h3>
                  <p className="text-[12px] leading-[19px] tracking-tight mb-3 text-[#0D4248]">
                    {translations.waiver_premium_desc}
                    <br />{" "}
                    <span className="text-[#A8A9AC] mt-4 block">(LR148B )</span>
                  </p>
                </div>
              </li>
              <li className="lg:px-2.5 px-1 md:w-[270px] min-w-[208px] md:min-w-[250px] whitespace-normal reveal-up reveal-delay-2">
                <div className="bg-[#CBD6D7] rounded-full md:px-5 px-[14px] md:py-24 h-full md:min-h-[505px] pt-[70px] pb-10">
                  <img src={BenefitsIconMobile2} className="mb-4" alt="" />
                  <h3 className="md:text-[14px] text-[14px] md:leading-[18px] leading:[20px] font-semibold mb-4 text-[#0D4248]">
                    {translations.accidental_death_title}
                  </h3>
                  <p className="text-[12px] leading-[19px] tracking-tight mb-3 text-[#0D4248]">
                    {translations.accidental_death_desc}
                    <br />{" "}
                    <span className="text-[#A8A9AC] mt-4 block">(LR195B)</span>
                  </p>
                </div>
              </li>
              <li className="lg:px-2.5 px-1 md:w-[270px] min-w-[208px] md:min-w-[250px] whitespace-normal reveal-up reveal-delay-3">
                <div className="bg-[#D8ECED] rounded-full h-full md:min-h-[505px]">
                  <img src={BenefitsMobileImage} className="h-full" alt="" />
                </div>
              </li>
              <li className="lg:px-2.5 px-1 md:w-[270px] min-w-[208px] md:min-w-[250px] whitespace-normal reveal-up reveal-delay-4">
                <div className="bg-[#F7F6F2] rounded-full md:px-5 px-[14px] md:py-24 h-full md:min-h-[505px] pt-[70px] pb-10">
                  <img src={BenefitsIconMobile3} className="mb-4" alt="" />
                  <h3 className="md:text-[14px] text-[14px] md:leading-[18px] leading:[20px] font-semibold mb-4 text-[#0D4248]">
                    {translations.return_premium_title}
                  </h3>
                  <p className="text-[12px] leading-[19px] tracking-tight mb-3 text-[#0D4248]">
                    {translations.return_premium_desc}
                    <br />{" "}
                    <span className="text-[#A8A9AC] mt-4 block">(LR-151B)</span>
                  </p>
                </div>
              </li>
              <li className="lg:px-2.5 px-1 md:w-[270px] min-w-[208px] md:min-w-[250px] whitespace-normal reveal-up reveal-delay-5">
                <div className="bg-[#FFF4D8] rounded-full md:px-5 px-[14px] md:py-24 h-full md:min-h-[505px] pt-[70px] pb-10">
                  <img src={BenefitsIconMobile4} className="mb-4" alt="" />
                  <h3 className="md:text-[14px] text-[14px] md:leading-[18px] leading:[20px] font-semibold mb-4 text-[#0D4248]">
                    {translations.additional_insured_title}
                  </h3>
                  <p className="text-[12px] leading-[19px] tracking-tight mb-3 text-[#0D4248]">
                    {translations.additional_insured_desc}
                    <br />
                    <span className="text-[#A8A9AC] mt-4 block">(LR150B)</span>
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div
          id="types-of-coverage"
          className="termsType py-[4rem] lg:py-[6rem] md:py-[8rem]"
        >
          <div className="container">
            <div className="flex flex-col lg:flex-row ">
              <div className="lg:max-w-[310px] reveal-up mr-16 lg:pl-0 pl-4 types-coverage-header">
                <p className="text-sm md:text-[10.5px] md:leading-[14.7px] xl:text-sm xl:leading-normal text-gray-600 mb-1 learnmoreacc items-baseline">
                  {translations.select_term}
                </p>
                <h2 className="text-[24px] md:text-[30px] md:leading-[33px] xl:text-[40px] xl:leading-[44px] leading-[28px] font-semibold mb-2 tracking-tight extra-title-heading">
                  {translations.variousTypesheading}
                </h2>
              </div>
              <div className="w-full lg:block hidden reveal-up reveal-delay-1 types-coverage-content">
                <div className="flex space-x-2 items-end mt-4 px-8">
                  <div className="flex items-start flex-col w-[20%] p-2">
                    <span className="text-[14px] md:text-[10.5px] xl:text-[14px] mb-0 ">
                      {translations.termsTable.termType}
                    </span>
                  </div>
                  <div className="flex items-center flex-col p-2 w-[13.33%]">
                    <span className="w-4 h-4 rounded-full bg-[#FFE9B1] mb-1 term-circle"></span>
                    <span className="text-[14px] md:text-[10.5px] xl:text-[14px] font-bold">
                      {translations.termsTable.term10}
                    </span>
                  </div>
                  <div className="flex items-center flex-col p-2 w-[13.33%]">
                    <span className="w-4 h-4 rounded-full bg-[#AFA07B] mb-1 term-circle"></span>
                    <span className="text-[14px] md:text-[10.5px] xl:text-[14px] font-bold">
                      {translations.termsTable.term15}
                    </span>
                  </div>
                  <div className="flex items-center flex-col p-2 w-[13.33%]">
                    <span className="w-4 h-4 rounded-full bg-[#187C85] mb-1 term-circle"></span>
                    <span className="text-[14px] md:text-[10.5px] xl:text-[14px] font-bold">
                      {translations.termsTable.term20}
                    </span>
                  </div>
                  <div className="flex items-center flex-col p-2 w-[13.33%]">
                    <span className="w-4 h-4 rounded-full bg-[#ED1C2C] mb-1 term-circle"></span>
                    <span className="text-[14px] md:text-[10.5px] xl:text-[14px] font-bold">
                      {translations.termsTable.term30}
                    </span>
                  </div>
                  <div className="flex items-center flex-col p-2 w-[13.33%]">
                    <span className="w-4 h-4 rounded-full bg-[#53BCC8] mb-1 term-circle"></span>
                    <span className="text-[14px] md:text-[10.5px] xl:text-[14px] font-bold">
                      {translations.termsTable.term85}
                    </span>
                  </div>
                  <div className="flex items-center flex-col p-2 w-[13.33%]">
                    <span className="w-4 h-4 rounded-full bg-[#0D4248] mb-1 term-circle"></span>
                    <span className="text-[14px] md:text-[10.5px] xl:text-[14px] font-bold">
                      {translations.termsTable.term100}
                    </span>
                  </div>
                </div>

                <div className="mt-2 types-coverage-table-div">
                  {/* First Table */}
                  <div className="bg-[#FFF4D8] rounded-full p-8">
                    <table className="w-full text-left border-collapse">
                      <thead>
                        <tr>
                          <th className="p-2 w-[20%] text-[14px] md:text-[10.5px] xl:text-[14px] font-bold align-top leading-[18px] md:leading-[14px] xl:leading-[18px]">
                            {translations.termsTable.issueAge}
                          </th>
                          <th className="p-2 w-[13.33%] text-[14px] md:text-[10.5px] xl:text-[14px] font-bold text-center align-top leading-[18px] md:leading-[14px] xl:leading-[18px]">
                            {translations.termsTable.years18_75}
                          </th>
                          <th className="p-2 w-[13.33%] text-[14px] md:text-[10.5px] xl:text-[14px] font-bold text-center align-top leading-[18px] md:leading-[14px] xl:leading-[18px]">
                            {translations.termsTable.years18_70}
                          </th>
                          <th className="p-2 w-[13.33%] text-[14px] md:text-[10.5px] xl:text-[14px] font-bold text-center align-top leading-[18px] md:leading-[14px] xl:leading-[18px]">
                            {translations.termsTable.years18_49}
                          </th>
                          <th className="p-2 w-[13.33%] text-[14px] md:text-[10.5px] xl:text-[14px] font-bold text-center align-top leading-[18px] md:leading-[14px] xl:leading-[18px]">
                            {translations.termsTable.years18_49}
                          </th>
                          <th className="p-2 w-[13.33%] text-[14px] md:text-[10.5px] xl:text-[14px] font-bold text-center align-top leading-[18px] md:leading-[14px] xl:leading-[18px]">
                            {translations.termsTable.years18_49}
                          </th>
                          <th className="p-2 w-[13.33%] text-[14px] md:text-[10.5px] xl:text-[14px] font-bold text-center align-top leading-[18px] md:leading-[14px] xl:leading-[18px]">
                            {translations.termsTable.years18_49}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="p-2 font-bold text-[14px] md:text-[10.5px] xl:text-[14px] w-[20%] align-top leading-[18px] md:leading-[14px] xl:leading-[18px]">
                            {translations.termsTable.minimumCovered}
                          </td>
                          <td className="p-2 w-[13.33%] text-[14px] md:text-[10.5px] xl:text-[14px] text-center align-top leading-[18px] md:leading-[14px] xl:leading-[18px]">
                            {translations.termsTable.amount500}
                          </td>
                          <td className="p-2 w-[13.33%] text-[14px] md:text-[10.5px] xl:text-[14px] text-center align-top leading-[18px] md:leading-[14px] xl:leading-[18px]">
                            {translations.termsTable.amount500}
                          </td>
                          <td className="p-2 w-[13.33%] text-[14px] md:text-[10.5px] xl:text-[14px] text-center align-top leading-[18px] md:leading-[14px] xl:leading-[18px]">
                             {translations.termsTable.amount300}
                          </td>
                          <td className="p-2 w-[13.33%] text-[14px] md:text-[10.5px] xl:text-[14px] text-center align-top leading-[18px] md:leading-[14px] xl:leading-[18px]">
                            {translations.termsTable.amount300}
                          </td>
                          <td className="p-2 w-[13.33%] text-[14px] md:text-[10.5px] xl:text-[14px] text-center align-top leading-[18px] md:leading-[14px] xl:leading-[18px]">
                            {translations.termsTable.amount300}
                          </td>
                          <td className="p-2 w-[13.33%] text-[14px] md:text-[10.5px] xl:text-[14px] text-center align-top leading-[18px] md:leading-[14px] xl:leading-[18px]">
                             {translations.termsTable.amount300}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* Second Table */}
                  <div className="bg-[#91DDE6] bg-opacity-30 rounded-full p-8 mt-3">
                    <table className="w-full text-left border-collapse">
                      <thead>
                        <tr>
                          <th className="p-2 w-[20%] text-[14px] md:text-[10.5px] xl:text-[14px] leading-[18px] md:leading-[14px] xl:leading-[18px]">
                            {translations.termsTable.issueAge}
                          </th>
                          <th className="p-2 w-[13.33%] text-[14px] md:text-[10.5px] xl:text-[14px] text-center"></th>
                          <th className="p-2 w-[13.33%] text-[14px] md:text-[10.5px] xl:text-[14px] text-center"></th>
                          <th className="p-2 w-[13.33%] text-[14px] md:text-[10.5px] xl:text-[14px] text-center leading-[18px] md:leading-[14px] xl:leading-[18px]">
                            {translations.termsTable.years50_65}
                          </th>
                          <th className="p-2 w-[13.33%] text-[14px] md:text-[10.5px] xl:text-[14px] text-center leading-[18px] md:leading-[14px] xl:leading-[18px]">
                            {translations.termsTable.years50_55}
                          </th>
                          <th className="p-2 w-[13.33%] text-[14px] md:text-[10.5px] xl:text-[14px] text-center leading-[18px] md:leading-[14px] xl:leading-[18px]">
                            {translations.termsTable.years50_65}
                          </th>
                          <th className="p-2 w-[13.33%] text-[14px] md:text-[10.5px] xl:text-[14px] text-center leading-[18px] md:leading-[14px] xl:leading-[18px]">
                            {translations.termsTable.years50_80}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="p-2 font-bold text-[14px] md:text-[10.5px] xl:text-[14px] w-[20%] leading-[18px] md:leading-[14px] xl:leading-[18px]">
                            {translations.termsTable.minimumAmount}
                          </td>
                          <th className="p-2 w-[13.33%] text-[14px] md:text-[10.5px] xl:text-[14px] text-center"></th>
                          <th className="p-2 w-[13.33%] text-[14px] md:text-[10.5px] xl:text-[14px] text-center"></th>
                          <td className="p-2 w-[13.33%] text-[14px] md:text-[10.5px] xl:text-[14px] text-center leading-[18px] md:leading-[14px] xl:leading-[18px]">
                            {translations.termsTable.amount250}
                          </td>
                          <td className="p-2 w-[13.33%] text-[14px] md:text-[10.5px] xl:text-[14px] text-center leading-[18px] md:leading-[14px] xl:leading-[18px]">
                            {translations.termsTable.amount250}
                          </td>
                          <td className="p-2 w-[13.33%] text-[14px] md:text-[10.5px] xl:text-[14px] text-center leading-[18px] md:leading-[14px] xl:leading-[18px]">
                           {translations.termsTable.amount250}
                          </td>
                          <td className="p-2 w-[13.33%] text-[14px] md:text-[10.5px] xl:text-[14px] text-center leading-[18px] md:leading-[14px] xl:leading-[18px]">
                            {translations.termsTable.amount250}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div className="w-full lg:hidden block">
                <div className="mt-8 px-8">
                  <div className="mb-4 reveal-up">
                    <div className="flex items-end border-b-[1px] border-solid border-[#AFA07B] pb-3 mb-4">
                      <h2 className="text-[12px] mb-0 px-2 w-[33.33%] pl-0 tracking-tight">
                        Term Type
                      </h2>
                      <div className="flex items-center flex-col px-2 w-[33.33%] mb-[6px]">
                        <span className="w-2 h-2 rounded-full bg-[#FFE9B1] mb-1"></span>
                        <span className="text-[12px] font-bold tracking-tight">
                          Term 10
                        </span>
                      </div>
                      <div className="flex items-center flex-col px-2 w-[33.33%] mb-[6px]">
                        <span className="w-2 h-2 rounded-full bg-[#AFA07B] mb-1"></span>
                        <span className="text-[12px] font-bold pr-0 tracking-tight">
                          Term 15
                        </span>
                      </div>
                    </div>
                    <div className="flex items-center pb-2">
                      <h2 className="text-[12px] font-bold mb-0 px-2 w-[33.33%] pl-0 tracking-tight">
                        Issue Age
                      </h2>
                      <div className="flex items-center flex-col px-2 w-[33.33%] text-[12px] tracking-tight">
                        18 to 75 years
                      </div>
                      <div className="flex items-center flex-col px-2 w-[33.33%] text-[12px] pr-0 tracking-tight">
                        18 to 70 years
                      </div>
                    </div>
                    <div className="flex items-center pb-2">
                      <h2 className="text-[12px] font-bold mb-0 px-2 w-[33.33%] pl-0 tracking-tight">
                        Minimum coverall insured
                      </h2>
                      <div className="flex items-center flex-col px-2 w-[33.33%] text-[12px] tracking-tight">
                        {translations.termsTable.amount500}
                      </div>
                      <div className="flex items-center flex-col px-2 w-[33.33%] text-[12px] pr-0 tracking-tight">
                        {translations.termsTable.amount500}
                      </div>
                    </div>
                  </div>

                  <div className="mb-6 reveal-up reveal-delay-1">
                    <div className="flex items-end border-b-[1px] border-solid border-[#AFA07B] pb-3 mb-4">
                      <h2 className="text-[12px] mb-0 px-2 w-[33.33%] pl-0 tracking-tight">
                        Term Type
                      </h2>
                      <div className="flex items-center flex-col px-2 w-[33.33%] mb-[6px]">
                        <span className="w-2 h-2 rounded-full bg-[#187C85] mb-1 tracking-tight"></span>
                        <span className="text-[12px] font-bold tracking-tight">
                          Term 20
                        </span>
                      </div>
                      <div className="flex items-center flex-col px-2 w-[33.33%] pr-0 mb-[6px]">
                        <span className="w-2 h-2 rounded-full bg-[#ED1C2C] mb-1"></span>
                        <span className="text-[12px] font-bold tracking-tight">
                          Term 30
                        </span>
                      </div>
                    </div>
                    <div className="flex items-center pb-2">
                      <h2 className="text-[12px] font-bold mb-0 px-2 w-[33.33%] pl-0 tracking-tight">
                        Issue Age
                      </h2>
                      <div className="flex items-center flex-col  px-2 w-[66.66%] text-[12px] tracking-tight">
                        <div className="flex items-center px-2 w-full text-[12px]">
                          <div className="flex items-center justify-center  px-0 w-[50%] text-[12px] tracking-tight">
                            18 to 49 years
                          </div>
                          <div className="flex items-center justify-center px-2 w-[50%] text-[12px] pr-0 tracking-tight">
                            18 to 49 years
                          </div>
                        </div>
                        <div className="flex items-center px-2 w-full text-[12px] bg-[#FFF4D8] rounded-full mt-2">
                          <div className="flex items-center justify-center px-0 w-[50%] text-[12px] tracking-tight">
                            50 to&nbsp;<span className="font-bold">65</span>
                            &nbsp;years
                          </div>
                          <div className="flex items-center justify-center px-2 w-[50%] text-[12px] pr-0 tracking-tight">
                            50 to&nbsp;<span className="font-bold">55</span>
                            &nbsp;years
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center mt-4 pb-2">
                      <h2 className="text-[12px] font-bold mb-0 px-2 w-[33.33%] pl-0 tracking-tight">
                        Minimum coverall insured
                      </h2>
                      <div className="flex items-center flex-col  px-2 w-[66.66%] text-[12px] pr-0">
                        <div className="flex items-center px-2 w-full text-[14px]">
                          <div className="flex items-center justify-center  px-2 w-[50%] text-[12px] tracking-tight">
                           {translations.termsTable.amount300}
                          </div>
                          <div className="flex items-center justify-center px-2 w-[50%] text-[12px] pr-0 tracking-tight">
                            {translations.termsTable.amount300}
                          </div>
                        </div>
                        <div className="flex items-center px-2 w-full text-[14px] bg-[#FFF4D8] rounded-full mt-2">
                          <div className="flex items-center justify-center px-2 w-[50%] text-[12px] tracking-tight">
                            {translations.termsTable.amount250}
                          </div>
                          <div className="flex items-center justify-center px-2 w-[50%] text-[12px] pr-0 tracking-tight">
                           {translations.termsTable.amount250}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mb-6 reveal-up reveal-delay-2">
                    <div className="flex items-end border-b-[1px] border-solid border-[#AFA07B] pb-3 mb-4">
                      <h2 className="text-[12px] mb-0 px-2 w-[33.33%] pl-0 tracking-tight">
                        Term Type
                      </h2>
                      <div className="flex items-center flex-col px-2 w-[33.33%] mb-[6px]">
                        <span className="w-2 h-2 rounded-full bg-[#53BCC8] mb-1"></span>
                        <span className="text-[12px] font-bold tracking-tight">
                          Term 85
                        </span>
                      </div>
                      <div className="flex items-center flex-col px-2 w-[33.33%] mb-[6px]">
                        <span className="w-2 h-2 rounded-full bg-[#0D4248] mb-1"></span>
                        <span className="text-[12px] font-bold tracking-tight">
                          Term 100
                        </span>
                      </div>
                    </div>
                    <div className="flex items-center pb-2">
                      <h2 className="text-[12px] font-bold mb-0 px-2 w-[33.33%] pl-0 tracking-tight">
                        Issue Age
                      </h2>
                      <div className="flex items-center flex-col  px-2 w-[66.66%] text-[12px] pr-0">
                        <div className="flex items-center px-0 w-full text-[12px]">
                          <div className="flex items-center justify-center  px-2 w-[50%] text-[12px] tracking-tight">
                            18 to 49 years
                          </div>
                          <div className="flex items-center justify-center px-2 w-[50%] text-[12px] tracking-tight">
                            18 to 49 years
                          </div>
                        </div>
                        <div className="flex items-center px-0 w-full text-[12px] bg-[#CBDCDE] rounded-full mt-2">
                          <div className="flex items-center justify-center px-2 w-[50%] text-[12px] tracking-tight">
                            50 to&nbsp;<span className="font-bold">65</span>
                            &nbsp;years
                          </div>
                          <div className="flex items-center justify-center px-2 w-[50%] text-[12px] tracking-tight">
                            50 to&nbsp;<span className="font-bold">80</span>
                            &nbsp;years
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center mt-4 pb-2">
                      <h2 className="text-[14px] font-bold mb-0 px-2 w-[33.33%] pl-0 tracking-tight">
                        Minimum coverall insured
                      </h2>
                      <div className="flex items-center flex-col  px-2 w-[66.66%] text-[14px] pr-0">
                        <div className="flex items-center px-2 w-full text-[14px]">
                          <div className="flex items-center justify-center  px-2 w-[50%] text-[12px] tracking-tight">
                            {translations.termsTable.amount300}
                          </div>
                          <div className="flex items-center justify-center px-2 w-[50%] text-[12px] tracking-tight">
                            {translations.termsTable.amount300}
                          </div>
                        </div>
                        <div className="flex items-center px-2 w-full text-[14px] bg-[#CBDCDE] rounded-full mt-2">
                          <div className="flex items-center justify-center px-2 w-[50%] text-[12px] tracking-tight">
                            {translations.termsTable.amount250}
                          </div>
                          <div className="flex items-center justify-center px-2 w-[50%] text-[12px] tracking-tight">
                             {translations.termsTable.amount250}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <FAQs />
        <HealthInsuranceHero />
      </section>
    </div>
  );
};

export default TermLifeInsurance;
